import { Component } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { InstitutiiSettingsSidebar } from 'src/app/utils/enum/sidebar-settings';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-institutii-settings',
    templateUrl: './institutii-settings.component.html',
    styleUrls: ['./institutii-settings.component.scss'],
})
export class InstitutiiSettingsComponent {
    readonly InstitutiiSettingsSidebar = InstitutiiSettingsSidebar;
    selectedComponent!: InstitutiiSettingsSidebar;
    env = environment;
    filteredComponents: string[] = [];

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        this.filteredComponents = [...this.componentKeys];

        if (!true) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== InstitutiiSettingsSidebar.ANI)
        }
        if (!true) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== InstitutiiSettingsSidebar.CATEGORII_DOCUMENTE)
        }
        if (!true) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== InstitutiiSettingsSidebar.TIPURI_DOCUMENTE)
        }
        if (!true) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== InstitutiiSettingsSidebar.SECTIUNI_PUBLICE)
        }
    }

    componentMapping: Record<InstitutiiSettingsSidebar, string> = {
        [InstitutiiSettingsSidebar.ANI]: 'app-ani',
        [InstitutiiSettingsSidebar.CATEGORII_DOCUMENTE]: 'app-categorii-documente',
        [InstitutiiSettingsSidebar.TIPURI_DOCUMENTE]: 'app-tipuri-documente',
        [InstitutiiSettingsSidebar.SECTIUNI_PUBLICE]: 'app-sectiuni-publice',
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;
}
